import axios from "axios";
import { getInstance } from "@/auth/auth0";

const DataExtractorPlugin = {
    install(Vue) {
        Vue.prototype.$getData = async (url) => {
            if (getInstance().auth0Client) {
                const accessToken = (await getInstance().auth0Client.getTokenSilently({ detailedResponse: true }))
                    ?.id_token;

                return axios({
                    method: "GET",
                    url,
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }).then((response) => response);
            }
        };
    },
};

export default DataExtractorPlugin;
